import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { T, RADIUS, SHADOW } from '@/lib/tokens';
import { QuickAddItemForm } from '@/components/QuickAddItemForm';

interface AddItemDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  groupId: string;
  onOpenExistingItems?: () => void;
}

/**
 *
 * @param root0
 * @param root0.open
 * @param root0.onOpenChange
 * @param root0.groupId
 * @param root0.onOpenExistingItems
 */
export function AddItemDialog({ open, onOpenChange, groupId, onOpenExistingItems }: AddItemDialogProps) {
  const [dialogTab, setDialogTab] = useState<'create' | 'existing'>('create');

  const resetForm = () => {
    setDialogTab('create');
  };

  const handleFromMyItems = () => {
    if (onOpenExistingItems) {
      onOpenChange(false);
      onOpenExistingItems();
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onOpenChange={(nextOpen) => {
          onOpenChange(nextOpen);
          if (!nextOpen) resetForm();
        }}
      >
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Add Item</DialogTitle>
            <DialogDescription>Add an item you want to share with the group.</DialogDescription>
          </DialogHeader>
          <div className="space-y-4">
            {/* Tab selector */}
            <div style={{ display: 'flex', gap: 8 }}>
              <button
                type="button"
                onClick={handleFromMyItems}
                style={{
                  flex: 1,
                  padding: '8px 12px',
                  borderRadius: RADIUS.sm,
                  background: T.surface,
                  color: T.text,
                  border: `1px solid ${T.border}`,
                  fontSize: 13,
                  fontWeight: 600,
                  cursor: 'pointer',
                  fontFamily: 'inherit',
                }}
              >
                From My Items
              </button>
              <button
                type="button"
                onClick={() => setDialogTab('create')}
                style={{
                  flex: 1,
                  padding: '8px 12px',
                  borderRadius: RADIUS.sm,
                  background: dialogTab === 'create' ? T.accent : T.surface,
                  color: dialogTab === 'create' ? T.white : T.text,
                  border: dialogTab === 'create' ? 'none' : `1px solid ${T.border}`,
                  fontSize: 13,
                  fontWeight: 600,
                  cursor: 'pointer',
                  fontFamily: 'inherit',
                  boxShadow: dialogTab === 'create' ? SHADOW.btn.accent : 'none',
                }}
              >
                Create New
              </button>
            </div>

            {/* Create New form */}
            {dialogTab === 'create' && (
              <QuickAddItemForm
                groupId={groupId}
                onItemCreated={() => {
                  onOpenChange(false);
                  resetForm();
                }}
              />
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
